import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-cep-camera-tile',
    templateUrl: './cep-camera-tile.component.html',
    styleUrls: ['./cep-camera-tile.component.scss'],
    standalone: false
})
export class CEPCameraTileComponent {

  @Input()
  url: string;


}
